"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisAssertionDefinitionRefSchema = exports.AnalysisAgentTypeSchema = exports.AnalysisAgentType = void 0;
const zod_1 = require("zod");
var AnalysisAgentType;
(function (AnalysisAgentType) {
    AnalysisAgentType["Validation"] = "validation";
    AnalysisAgentType["Finalization"] = "finalization";
    AnalysisAgentType["SubjectGeneration"] = "subject-generation";
    AnalysisAgentType["TriggerFilter"] = "trigger-filter";
})(AnalysisAgentType || (exports.AnalysisAgentType = AnalysisAgentType = {}));
exports.AnalysisAgentTypeSchema = zod_1.default.nativeEnum(AnalysisAgentType);
exports.AnalysisAssertionDefinitionRefSchema = zod_1.default.object({
    assertionDefinitionId: zod_1.default.string(),
    slug: zod_1.default.string(),
});
//# sourceMappingURL=agent-definition.js.map